import api from ".";
import cookiesModifier from "../utils/cookies";

export const updatePage = async (data: any) => {
    const url = `pages/${data.id}`;

    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.patch(url, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const createPage = async (payload: { sectionId: number, title: string, help: string, criteriaGroupId: number | undefined }) => {
    const url = `pages`;
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post(url, payload);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const reorderPage = async (payload: { id: number, action: string }) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`pages/reorder/${payload.id}/${payload.action}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deletePage = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`pages/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}